import { clearAllFeatureFlags, setFeatureFlags } from './cookies';
import { parseFlagQuery } from './parseFlagQuery';

export function processFeatureFlagsFromURL(): void {
  if (typeof window === 'undefined') return;
  const query = parseFlagQuery(new URLSearchParams(window.location.search));
  if (!query) return;

  const search = query.cleanSearch.toString();
  const target = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash ?? ''}`;
  window.history.replaceState(null, '', target);

  if (query.clear) clearAllFeatureFlags();
  else if (Object.keys(query.values).length > 0) setFeatureFlags(query.values);
}
